<form name="searchBox" ng-submit="submit()">
  <uib-accordion>
    <uib-accordion-group template-url="search-box-template.html" is-open="showSearch">
      <ng-transclude></ng-transclude>
      <div class="row">
        <div class="col-xs-12 text-right">
          <button type="button" class="btn btn-white" ng-if="showClear" title="Limpar filtros" ng-click="clear()">
            Limpar
            <i class="fa fa-times"></i>
          </button>
          <button type="submit" class="btn btn-success" ng-disabled="searchBox.$invalid">
            Buscar
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </uib-accordion-group>
  </uib-accordion>
</form>

<script type="text/ng-template" id="search-box-template.html">
  <div class="ibox" id="{{::headingId}}">
    <div class="ibox-title">
      <h5>
        <i class="fa fa-search"></i>
        Filtrar
      </h5>
      <div class="ibox-tools">
        <a ng-click="toggleOpen()" uib-tabindex-toggle>
          <i class="fa" ng-class="isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </a>
      </div>
    </div>
    <div class="ibox-content" id="{{::panelId}}" uib-collapse="!isOpen" ng-transclude></div>
  </div>
</script>
